module.exports = __webpack_public_path__ + "img/kiwoom_round_phone.29955054.png";